
import { call, takeEvery, delay } from "redux-saga/effects";
import { message } from 'antd';
import register from "../Actions/register";
import { createPreUserAccount, createPreUserFreeAccount, changePasswordRequest, ValidateTokenPasswordRequest } from '../Api/User';
import { startLoading, stopLoading } from "../LoadingHelper";
import { CATEGORY_GA, eventGA } from  '../Helpers/GoogleAnalytics';
import { authenticate } from '../Sagas/login';
const { REGISTER_USER, REGISTER_USER_FREE_PLAN, SET_NEW_PASSWORD, REQUEST_VALIDATE_PASSWORD_TOKEN } = register.types;

export function* registerUser({ data }) {
    const loadingId = yield call(startLoading);
    try {
        let { values, history } = data;
        const response = yield call(createPreUserAccount, values);
        if (response && response.status === 'success') {
            eventGA(CATEGORY_GA.register.endRegistration);
            message.success('Guardado correctamente', 5);
            yield delay(1500);
            history.push(`/buy-license/preUser/${values.email}`);
        } else {
            message.error(response.message, 5);
        }
    } catch (error) {
        message.error(error.message, 5);
    } finally {
        yield call(stopLoading, loadingId);
    }
}

export function* registerUserFreePlan({data}) {
    const loadingId = yield call(startLoading);
    try {
        const response = yield call(createPreUserFreeAccount, data);
        if (response && response.status === 'success') {            
            message.success('Guardado correctamente', 5);
            const loginData = {
                values: {
                    username: data.email,
                    password: data.password
                },
                history: data.history
            }
            yield delay(1500);
            yield call(authenticate, {data:loginData});
        } else {
            message.error(response.message, 5);
        }        
    } catch (error) {
        message.error(error.message, 5);
    } finally {
        yield call(stopLoading, loadingId);
    }
}

export function* setNewPassword({data}) {
    const loadingId = yield call(startLoading);
    try {
        const response = yield call(changePasswordRequest, data);        
        if (response && response.status === 'success') {    
            data.history.push('/updated-password');
        } else {
            message.error(response.message, 5);
        }        
    } catch (error) {
        message.error(error.message, 5);
    } finally {
        yield call(stopLoading, loadingId);
    }
}

export function* validatePasswordToken({data}) {    
    const loadingId = yield call(startLoading);
    try {        
        const response = yield call(ValidateTokenPasswordRequest, data);        
        if (response && response.status !== 'success') {  
            message.error(response.message, 5);  
            data.history.push('/updated-password-expired');
        }
    } catch (error) {
        message.error(error.message, 5);
    } finally {
        yield call(stopLoading, loadingId);
    }
}

export function* registerSaga() {
    yield takeEvery(REGISTER_USER, registerUser);
    yield takeEvery(REGISTER_USER_FREE_PLAN, registerUserFreePlan);
    yield takeEvery(SET_NEW_PASSWORD, setNewPassword);
    yield takeEvery(REQUEST_VALIDATE_PASSWORD_TOKEN, validatePasswordToken);
}